// CandidateDetailsPage.jsx
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Badge,Accordion } from "react-bootstrap";
import { AddBenchCandidatesProfile_BulkImport, AddBenchCandidatesProfile_BulkImportwithDocs, Contact,usStates, usStateCities,IndiaStates,IndiaStateCities, } from "../../apiconstants/constants";
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import LoadingSpinner from "../../helpers/loadingspinner";
import Swal from "sweetalert2";
import { useCountry } from "../../contexts/countrycodecontext.js";
import { FaSave } from "react-icons/fa";

const CandidateDetailsPage = () => {
  const { id } = useParams(); // get :id from URL
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(false);
 let Guid="";
  const { selectedCountry} = useCountry();
  const employerGuid = localStorage.getItem("employerGuid")
  const loginemail = localStorage.getItem("email")
  const guid = localStorage.getItem("guid");
  const roleID = localStorage.getItem("roleID")
  const token = localStorage.getItem('jwtToken');  
  const allKeys = ["0","1","2","3","4","5","6","7","8"];
const [activeKeys, setActiveKeys] = useState(allKeys);const toggleAccordion = (key) => {
  setActiveKeys((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );
};


  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  
const handleSaveCandidate = async () => {
  if (!candidate) return;

  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };
// --- Identify country ---
const country = candidate.country?.trim() || "";
let matchedState = "";
let matchedCity = "";

// Extract location data safely
const locationText = candidate.locations?.[0]?.text || "";
const region = candidate.region?.trim() || "";
const cityFromAPI = candidate.city?.trim() || "";
const possibleCity =
  cityFromAPI ||
  (locationText.includes(",") ? locationText.split(",")[0].trim() : "") ||
  region;

// --- United States Matching ---
if (country.toLowerCase().includes("united states")) {
  // Find the correct full "State - Code" value
  const stateObj = usStates.find(({ value }) => {
    const [stateName] = value.split(" - ");
    return region.toLowerCase() === stateName.toLowerCase();
  });

  if (stateObj) matchedState = stateObj.value; // e.g. "Texas - TX"

  // Match city
  if (matchedState) {
    const cities = usStateCities[matchedState];
    if (cities && possibleCity) {
      const foundCity = cities.find(
        (c) => c.toLowerCase() === possibleCity.toLowerCase()
      );
      matchedCity = foundCity || possibleCity || "Other";
    } else {
      matchedCity = possibleCity || "Other";
    }
  }
}

// --- India Matching ---
else if (country.toLowerCase().includes("india")) {
  const stateObj = IndiaStates.find(({ value }) => {
    const [stateName] = value.split(" - ");
    return region.toLowerCase() === stateName.toLowerCase();
  });

  if (stateObj) matchedState = stateObj.value; // e.g. "Telangana - TG"

  if (matchedState) {
    const cities = IndiaStateCities[matchedState];
    if (cities && possibleCity) {
      const foundCity = cities.find(
        (c) => c.toLowerCase() === possibleCity.toLowerCase()
      );
      matchedCity = foundCity || possibleCity || "Other";
    } else {
      matchedCity = possibleCity || "Other";
    }
  }
}

// --- Fallbacks ---
if (!matchedState && region) {
  // Try a loose match if exact didn't hit
  const looseMatch = usStates.find(({ value }) =>
    value.toLowerCase().includes(region.toLowerCase())
  );
  matchedState = looseMatch ? looseMatch.value : region;
}

if (!matchedCity) matchedCity = possibleCity || "Other";

// --- Address formatting ---
let addressValue = "Other";
if (matchedState.includes(" - ")) {
  const [stateName, stateCode] = matchedState.split(" - ");
  addressValue = `${stateName} - ${stateCode} - ${matchedCity}`;
} else {
  addressValue = `${matchedState} - ${matchedCity}`;
}

// Now use addressValue in the formatted data
const formattedData = [{
  userGuid: Guid,
  fullName: candidate.fullName,
  email: candidate?.email?.[0] || 'N/A',
  mobileNumber: candidate?.phone?.[0]?.toString() || '',
  dob: null,
  gender: 'Male',
  address: addressValue, // ✅ "Virginia - VA - Hampton"
  jobRole: 5,
  maritalStatus: 'married',
  technicalSkill: candidate.skills?.map(s => s.skill).join(", ") || '',
  experience: candidate.yearsOfExperience?.toString() || '',
  preferLocation: matchedState,
  workMode: 'Hybrid',
  profileSummery: candidate.profileSummary || '',
  billRate: candidate.billRate || '',
  payRate: candidate.payRate || '',
  workAuthorizationandValidity: candidate.workAuthorizationandValidity || '',
  employerName: candidate.employerName || '',
  ssn: candidate.ssn?.toString() || '',
  passportNo: candidate.passportNo || '',
  tworefrencesfromrecentproject: candidate.tworeferencesfromrecentproject || '',
  linkedInUrl: candidate.socialProfiles?.find(p => p.source === "linkedin")?.url || '',
  certifications: candidate.certifications?.join(", ") || '',
  createdBy: loginemail,
  countryID: selectedCountry,
  countryName: country,
}];

  const formData = new FormData();
  formData.append("CandidatesJson", JSON.stringify(formattedData));

  if (candidate.resume?.resumeData) {
    const resumeBlob = base64ToBlob(candidate.resume.resumeData, "application/pdf");
    formData.append("ResumeFiles", resumeBlob, `${candidate.fullName}_resume.pdf`);
  }

  try {
    const response = await axios.post(
      AddBenchCandidatesProfile_BulkImportwithDocs.APIURL,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.candidates && Array.isArray(response.data.candidates)) {
      const messages = response.data.candidates.map(c => {
        const { email, statusMessage } = c;
        if (email === "N/A") return `❌ <strong>Email doesn’t exist</strong> for that candidate.`;
        if (statusMessage === 'Inserted') return `✅ <strong>${email}</strong> added successfully.`;
        if (statusMessage === 'Duplicate or Already Exists') return `⚠️ <strong>${email}</strong> already exists.`;
        return `ℹ️ <strong>${email}</strong>: ${statusMessage}`;
      });

      Swal.fire({
        icon: 'info',
        title: 'Candidate Upload Summary',
        html: messages.join('<br>'),
        showConfirmButton: true
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Unexpected response format.',
        text: 'Please check the server response.',
        showConfirmButton: true
      });
    }
  } catch (err) {
    console.error("Error saving candidate:", err);
    Swal.fire({ icon: 'error', title: 'Error', text: err.message });
  }
};


  useEffect(() => {
 const fetchCandidate = async () => {
  try {
    setLoading(true);
    const response = await axios.get(`${Contact.APIURL}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`, // Add the Authorization header
      }
    });
    setCandidate(response.data);
  } catch (error) {
    console.error("Error fetching candidate:", error);
  } finally {
    setLoading(false);
  }
};
    fetchCandidate();
  }, [id]);
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, []);
if (loading) {
    return (
      <ConsultantLayout>
        <div className="d-flex justify-content-center align-items-center vh-100">
          <center><LoadingSpinner /></center>
        </div>
      </ConsultantLayout>
    );
  }

  if (!candidate) {
    return (
      <ConsultantLayout>
        <div className="text-center mt-5">No candidate data found.</div>
      </ConsultantLayout>
    );
  }
   const {
    fullName,
    email,
    phone,
    currentJobTitle,
    currentCompany,
    locations,
    yearsOfExperience,
    skills,
    socialProfiles,
    imageUrl,
    dateLastActive,
    dateLastUpdated,
  } = candidate;

  const linkedInProfile = socialProfiles?.find((p) => p.source === "linkedin");
  const diceProfile = socialProfiles?.find((p) => p.source === "Dice");
  return (
  <ConsultantLayout>
    {/* {loading ? (
                <center><LoadingSpinner /></center>
              ) : ( */}
    <div className="container mt-4">
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}> Candidate Details</h2>
          </div>
          <hr/>
      <Card className="p-4 shadow-sm border-0">
        <div>
         
   <button
  className="btn d-flex align-items-center gap-2 mt-3" 
  onClick={handleSaveCandidate}
  style={{ backgroundColor: "#00a7ac", borderColor: "#00a7ac", color: "#fff",float:"right",margin:5 }}
  title ="Save Candidate"
>
  <FaSave size={20} />
</button>

  </div>
        <div className="d-flex align-items-center gap-4">
         
          <img
            src={imageUrl || defaultimg}
            alt={fullName}
            className="rounded-circle"
            width={100}
            height={100}
          />
          <div>
            <h4 className="mb-1">{fullName}</h4>
            <div className="text-muted">
              {currentJobTitle} @ {currentCompany}
            </div>
            <Badge bg="success" className="mt-2">
              {yearsOfExperience || 0} yrs experience
            </Badge>
          </div>
        </div>

        <hr />

   <Accordion activeKey={activeKeys} alwaysOpen>

            {/* Basic Info */}
           <Accordion.Item eventKey="0">
            <Accordion.Header onClick={() => toggleAccordion("0")}>Basic Info</Accordion.Header>
              <Accordion.Body>
                       <p><strong>Full Name:</strong> {candidate.fullName}</p>
                       <p>
  <strong>Email:</strong>{" "}
  {candidate.email?.length > 0 ? candidate.email.join(", ") : "N/A"}
</p>
<p>
  <strong>Phone:</strong>{" "}
  {candidate.phone?.length > 0 ? candidate.phone.join(", ") : "N/A"}
</p>

                <p><strong>Current Job:</strong> {candidate.currentJobTitle} @ {candidate.currentCompany}</p>
                <p><strong>City:</strong> {candidate.city}</p>
                <p><strong>Region:</strong> {candidate.region}</p>
                <p><strong>Country:</strong> {candidate.country}</p>
                <p><strong>Years of Experience:</strong> {candidate.yearsOfExperience}</p>
                {/* <p><strong>Date Last Active:</strong> {candidate.dateLastActive}</p>
                <p><strong>Date Last Updated:</strong> {candidate.dateLastUpdated}</p>
                <p><strong>Resume Last Updated:</strong> {candidate.dateResumeLastUpdated}</p> */}
                <p><strong>Authorized to work in US:</strong> {candidate.authorizedToWorkInUS ? "Yes" : "No"}</p>
                <p><strong>Needs Sponsorship in US:</strong> {candidate.needsSponsorshipToWorkInUS ? "Yes" : "No"}</p>
                <p><strong>Authorized to work in Canada:</strong> {candidate.authorizedToWorkInCanada ? "Yes" : "No"}</p>
                <p><strong>Needs Sponsorship in Canada:</strong> {candidate.needsSponsorshipToWorkInCanada ? "Yes" : "No"}</p>
                <p><strong>US Citizen:</strong> {candidate.usCitizen ? "Yes" : "No"}</p>
                <p><strong>Likely to Move:</strong> {candidate.likelyToMove ? "Yes" : "No"}</p>
                <p><strong>Likely to Move Score:</strong> {candidate.likelyToMoveScore}</p>
                <p><strong>Is Third Party:</strong> {candidate.isThirdParty ? "Yes" : "No"}</p>
                <p><strong>Has Email:</strong> {candidate.hasEmail ? "Yes" : "No"}</p>
                <p><strong>Has Phone:</strong> {candidate.hasPhone ? "Yes" : "No"}</p>
                <p><strong>Security Allowance:</strong> {candidate.securityAllowance?.status ? "Yes" : "No"}</p>
                {candidate.desiredJobTitles?.length > 0 && <p><strong>Desired Job Titles:</strong> {candidate.desiredJobTitles.join(", ")}</p>}
              </Accordion.Body>
            </Accordion.Item>

            {/* Skills */}
            <Accordion.Item eventKey="1">
              <Accordion.Header onClick={() => toggleAccordion("1")}>Skills ({candidate.skills?.length || 0})</Accordion.Header>
              <Accordion.Body style={{ maxHeight: "200px", overflowY: "auto" }}>
                <ul>
                  {candidate.skills?.map((s, i) => (
                    <li key={i}>{s.skill} ({s.yearsUsed} yrs, last used: {s.lastUsed})</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Resume */}
            {candidate.resume?.resumeData && (
              <Accordion.Item eventKey="8">
              <Accordion.Header onClick={() => toggleAccordion("8")}>Resume</Accordion.Header>
                <Accordion.Body style={{ height: "500px", overflowY: "auto" }}>
                  <iframe
                    src={`data:application/pdf;base64,${candidate.resume.resumeData}`}
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                    title="Candidate Resume"
                  />
                </Accordion.Body>
              </Accordion.Item>
            )}

            {/* Education */}
            <Accordion.Item eventKey="2">
            <Accordion.Header onClick={() => toggleAccordion("2")}>Education</Accordion.Header>
              <Accordion.Body style={{ maxHeight: "150px", overflowY: "auto" }}>
                <ul>
                  {candidate.education?.map((edu, i) => (
                    <li key={i}>{edu.degree} - {edu.org} ({edu.location})</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Work History */}
            <Accordion.Item eventKey="3">
               <Accordion.Header onClick={() => toggleAccordion("3")}>Work History</Accordion.Header>
              <Accordion.Body style={{ maxHeight: "200px", overflowY: "auto" }}>
                {candidate.experience?.current && (
                  <p><strong>Current:</strong> {candidate.experience.current.title} @ {candidate.experience.current.org} ({candidate.experience.current.periodStart?.month}/{candidate.experience.current.periodStart?.year} - {candidate.experience.current.periodEnd?.month}/{candidate.experience.current.periodEnd?.year})</p>
                )}
                {candidate.experience?.history?.length > 0 && (
                  <ul>
                    {candidate.experience.history.map((job, i) => (
                      <li key={i}>
                        {job.title} @ {job.org} ({job.periodStart?.month}/{job.periodStart?.year} - {job.periodEnd?.month}/{job.periodEnd?.year})
                      </li>
                    ))}
                  </ul>
                )}
              </Accordion.Body>
            </Accordion.Item>

            {/* Locations */}
            <Accordion.Item eventKey="4">
             <Accordion.Header onClick={() => toggleAccordion("4")}>Locations</Accordion.Header>
              <Accordion.Body>
                <ul>
                  {candidate.locations?.map((loc, i) => (
                    <li key={i}>
                      {loc.text} (Lat: {loc.latitude}, Lon: {loc.longitude}, CountryCode: {loc.countryCode}, Source: {loc.source})
                    </li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Social Profiles */}
            <Accordion.Item eventKey="5">
            <Accordion.Header onClick={() => toggleAccordion("5")}>Social Profiles</Accordion.Header>
              <Accordion.Body>
                <ul>
                  {candidate.socialProfiles?.map((s, i) => (
                    <li key={i}>
                      <a href={s.url || "#"} target="_blank" rel="noreferrer">
                        <img src={s.icon_64} alt={s.source} width={20} style={{ marginRight: 5 }} />
                        {s.source}
                      </a>
                    </li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Work Permits */}
            <Accordion.Item eventKey="6">
             <Accordion.Header onClick={() => toggleAccordion("6")}>Work Permits</Accordion.Header>
              <Accordion.Body>
                {candidate.workPermitDocuments?.length > 0 && (
                  <ul>
                    {candidate.workPermitDocuments.map((doc, i) => <li key={i}>{doc}</li>)}
                  </ul>
                )}
                {candidate.workPermitLocations?.length > 0 && <p>{candidate.workPermitLocations.join(", ")}</p>}
              </Accordion.Body>
            </Accordion.Item>

            {/* Work Preferences */}
            <Accordion.Item eventKey="7">
              <Accordion.Header onClick={() => toggleAccordion("7")}>Work Preferences</Accordion.Header>
              <Accordion.Body>
              {candidate.workPreferences?.length > 0 && (
  <ul>
    {candidate.workPreferences.map((pref, i) => (
      <li key={i}>
        Employment Type:{" "}
        {Array.isArray(pref.employmentType)
          ? pref.employmentType.join(", ")
          : "N/A"}
        , Willing to Relocate:{" "}
        {pref.willingToRelocate ? "Yes" : "No"}, Travel Preference:{" "}
        {pref.travelPreference || "N/A"}
      </li>
    ))}
  </ul>
)}

              </Accordion.Body>
            </Accordion.Item>

          </Accordion>
      </Card>
    </div>
    </ConsultantLayout>
  
  );
};

export default CandidateDetailsPage;
